// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__ymhQY","modal_inner":"styles_modal_inner__JHRKi","profileBtn":"styles_profileBtn__3Kir6","icon":"styles_icon__vszv2"};